import React, { useEffect, useState } from "react"
import { useAppDispatch } from "hooks"

import Form from "./Form"
import DocumentTable from "./DocumentTable"

import { getEmployeesDocumentByEmployeeId } from "store/Employee/Documents/documents.slice"
import DocumentContext from "./documentContext"

import { EmployeeDocumentInterface } from "@type/employees.types"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"
import { useEmployeeScheduleDefaults } from "hooks/useScheduleDefaults"

const Documents = () => {
	const dispatch = useAppDispatch()
	useEmployeeScheduleDefaults()
	const { selectedEmployee = "" } = useSchedulesQueryParams()

	const [document, setDocument] = useState<EmployeeDocumentInterface | undefined>()

	const handleRow = (e: any) => setDocument(e)

	useEffect(() => {
		selectedEmployee && dispatch(getEmployeesDocumentByEmployeeId(selectedEmployee))
	}, [selectedEmployee])

	return (
		<DocumentContext.Provider value={{ handleRow, document }}>
			<div className="flex space-x-16">
				<div className="w-1/6">
					<Form />
				</div>
				<div className="w-3/5 pt-5">
					<DocumentTable />
				</div>
			</div>
		</DocumentContext.Provider>
	)
}

export default Documents
